import React from 'react';
import styles from '../style/BrowseBy.module.scss';
import { useOtherResource } from 'modules/website/hooks/useOtherResourcePage';
import { Link } from 'react-router-dom';
import BrowseByLoading from '../BrowseByLoading/BrowseByLoading';
export default function OtherReources() {
	const { isLoading, isError, payload, error } = useOtherResource();
	return (
		<div className={`py-2 ${styles.browseby}`}>
			<div className={`${styles.title}`}>Other Resources</div>
			<div className={styles.links}>
				{isLoading && <BrowseByLoading />}
				{isError && <div>{error}</div>}
				{payload &&
					Object.values(payload).map((item, index) => (
						<div className={styles.option} key={index}>
							<Link
								key={index}
								className={styles.link}
								to={item?.url}
							>
								{item?.title}
							</Link>
						</div>
					))}
			</div>
		</div>
	);
}
